import React from 'react';
import { useTranslation } from 'react-i18next';
import './RelatedProducts.css';
import Item from '../Item/item';
import { ProductSkeleton } from '../UI';
import { useProductsByCategory, useProducts } from '../../hooks/useProducts';
import {
  filterListableProducts,
  getProductImageUrl,
  getProductId,
  getProductName,
  getProductPrices,
  isProductInStock,
} from '../../utils/helpers';

const RelatedProducts = ({ categoryId, currentProductId }) => {
  const { t } = useTranslation(['products', 'common']);
  const categoryQuery = useProductsByCategory(categoryId, { limit: 6 });
  const allProductsQuery = useProducts({ limit: 6 });
  
  const { data, isLoading, error } = categoryId ? categoryQuery : allProductsQuery;
  
  const relatedProducts = filterListableProducts(data?.products || [])
    .filter((item) => getProductId(item) !== currentProductId)
    .slice(0, 5);

  if (isLoading) {
    return (
      <section className="related-section">
        <div className="related-container">
          <h2 className="section-title">{t('youMayAlsoLike')}</h2>
          <div className="related-grid">
            <ProductSkeleton count={5} />
          </div>
        </div>
      </section>
    );
  }

  if (error || relatedProducts.length === 0) {
    return null;
  }

  return (
    <section className="related-section">
      <div className="related-container">
        <h2 className="section-title">{t('youMayAlsoLike')}</h2>
        <div className="related-grid">
          {relatedProducts.map((item, i) => {
            const { price, comparePrice, fromPrice } = getProductPrices(item);
            return (
            <Item
                key={getProductId(item) || i}
                id={getProductId(item)}
                image={getProductImageUrl(item)}
                name={getProductName(item)}
                newPrice={price}
                oldPrice={comparePrice}
                fromPrice={fromPrice}
                sold={item.sold || item.salesCount || 0}
                rating={item.averageRating || item.rating || 4.5}
                shipping={item.freeShipping ? t('freeShipping', { ns: 'common' }) : t('standardShipping', { ns: 'common' })}
                inStock={isProductInStock(item)}
            />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RelatedProducts;
